/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import AllergyLegend from './allergy-legend';
import AllergyLegendDetail from './allergy-legend-detail';
import AllergyLegendUpdate from './allergy-legend-update';
import AllergyLegendDeleteDialog from './allergy-legend-delete-dialog';

const AllergyLegendRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<AllergyLegend />} />
    <Route path="new" element={<AllergyLegendUpdate />} />
    <Route path=":id">
      <Route index element={<AllergyLegendDetail />} />
      <Route path="edit" element={<AllergyLegendUpdate />} />
      <Route path="delete" element={<AllergyLegendDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default AllergyLegendRoutes;
